import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { apiUrlComponent } from '../common/api.url.component';
import { ApiService } from '../common/API/api.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import * as $ from 'jquery';
import {MatPaginator, MatTableDataSource} from '@angular/material';
import {BackRestrict} from '../common/backRestrict'

declare var config;

@Component({
  selector: 'app-partner',
  templateUrl: './partner.component.html',
  styleUrls: ['./partner.component.css']
})
export class PartnerComponent implements OnInit {
  @ViewChild('ddlenterprise') ddlenterprise: ElementRef;
  @ViewChild('ddlenterprise') ddlchanneltype: ElementRef;
  @ViewChild('ddlenterprise') ddllanguage: ElementRef;
  @ViewChild('ddlenterprise') ddlcountry: ElementRef;
  @ViewChild('ddlenterprise') ddlpricelogictype: ElementRef;
  @ViewChild('ddlenterprise') ddllogisticprovider: ElementRef;

    public Enterpriselist = [];
    public submitted: boolean = false;
  public dataSource :  MatTableDataSource<partnerInfo>;
  public Partnerlist: partnerInfo[]= [];
  public ChannelTypelist: any;
  public Languagelist: any;
  public Countrylist: any;
  public PriceLogicTypelist: any;
  public LogisticProviderlist: any;
  public TestProfilelist: any;
  public form: FormGroup;
  public ChannelForm : FormGroup;
  public responseResult = '';
  public $: any;
  public Cond_Partner: any;
  public dropdownlist: boolean;
  public modfyChannelTypeList: any;
  public modfyLanguageList: any;
  public modfyPriceLogicTypelist: any;
  public modfyCountrylist: any;
  public modfyLogisticProviderlist: any;
  public modfyTestProfilelist: any;
  public partnerID : any;
  public partnerName : any;
  public partnerChannelList : any;
  public channel : any = false;
  public showpartnerChannelList =[];

  private readonly notifier: NotifierService;
  public callForAddEnterprisePartner: boolean=true;
  public Currencylist=[];
  constructor(private _apiService: ApiService,private backrestrict:BackRestrict, private formbuilder: FormBuilder, private apiUrl: apiUrlComponent, notifierService: NotifierService) {
   
    this.form = formbuilder.group({
      Enterprise: ['', Validators.required],
      EnterprisePartnerID: [''],
      EnterprisePartner: ['', Validators.required],
      EnterprisePartnerCode: ['', Validators.required]
    });

    this.ChannelForm = formbuilder.group({
      ChannelType: ['', Validators.required],
      Language: ['', Validators.required],
      Country: ['', Validators.required],
      PriceLogicType: ['', Validators.required],
      LogisticProvider: ['', Validators.required],
      TestProfile: ['', Validators.required],
      Currency:['',Validators.required]
    });

    this.notifier = notifierService;
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public pageSizeOptions=[5,10,15,20];
  public pageSize=10;
  public length=10;
  public displayedColumns  = ['EnterpriseID', 'Enterprise','EnterpriseCode','BaseEnterprise', 'Action','ChannelConfig', 'IsActive'];
  
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  ngOnInit() {
    debugger
    this.backrestrict.clearBrowserBackHistory();
    this.GetPartner();
  }

  GetPartner() {
    debugger;
    this._apiService.get(config.urlpath + 'api/getpartner').subscribe(result => {
      debugger;
      if (result.Success === true) {
        this.Partnerlist = result.Data[0];
        debugger;
        this.dataSource = new MatTableDataSource(this.Partnerlist);
        this.dataSource.paginator = this.paginator;
        this.Enterpriselist = result.Data[1].filter(x=>x.Enterprise!=='Corporate');
        this.ChannelTypelist = result.Data[2];
        this.Languagelist = result.Data[3];
        this.Countrylist = result.Data[4];
        this.PriceLogicTypelist = result.Data[5];
        this.LogisticProviderlist = result.Data[6];
        this.TestProfilelist = result.Data[7];
        this.Currencylist = result.Data[8];
        this.partnerChannelList = result.Data[9];
        this.channel = true;
        if(this.partnerID!="" && this.partnerID!= null){
          this.showpartnerChannelList = [];
          this.showpartnerChannelList =  this.partnerChannelList.filter(x=>x.EnterprisePartnerID == this.partnerID);
        }
      }
      else {
        this.notifier.notify('error', 'An Error Occured');
      }
    },
      error => {
        console.log(error);
      }
    );
  }

  emptyform() {
    debugger;
    this.callForAddEnterprisePartner=true;
    this.form.reset();
    this.ChannelForm.reset();
    this.form.controls['Enterprise'].setValue('');
    }


  AddPartner() {
    debugger;
    
    if (this.form.valid) {
    var addbody = {
      EnterpriseID: this.form.controls.Enterprise.value,
      EnterprisePartnerCode: this.form.value.EnterprisePartnerCode,
      EnterprisePartner: this.form.value.EnterprisePartner,
      EnterprisePartnerID: null,
      // ChannelType: this.form.value.ChannelType,
      // Language: this.form.value.Language,
      // Country: this.form.value.Country,
      // PriceLogicType: this.form.value.PriceLogicType,
      // LogisticProvider: this.form.value.LogisticProvider,
      // TestProfile: this.form.value.TestProfile,
      // PriceLevelID: 2
    }
    this._apiService.post(config.urlpath + 'api/addpartner', addbody).subscribe(result => {
      if (result.Success === true) {
        //debugger;
        $('#ModalClsbtn').click();
        this.notifier.notify('success', 'Enterprise Added Successfully');
        // setTimeout(
        //   function () {
        //     location.reload(true);
        //   }, 2000);
        this.GetPartner();
      } else {
        // $('#ModalClsbtn').click();
        this.notifier.notify('error', 'An Error Occured');
      }
    },
      error => {
        console.log(error);
      }
    );
    }
    else{
      this.notifier.notify('error', 'Please enter or select all fields');
    }
  }

  AddChannel() {
    debugger;
    
      if (this.ChannelForm.valid) {

        if(this.showpartnerChannelList.length == 3){
          $('#ModalClsbtn').click();
          this.notifier.notify('warning', 'All Channel Already Selected');
          // setTimeout(
          //   function () {
          //     location.reload(true);
          //   }, 20);
        }
        else {
          var addbody = {
            EnterprisePartnerID: this.partnerID ,
            ChannelType: this.ChannelForm.value.ChannelType,
            Language: this.ChannelForm.value.Language, 
            Country: this.ChannelForm.value.Country,
            PriceLogicType: this.ChannelForm.value.PriceLogicType,
            LogisticProvider: this.ChannelForm.value.LogisticProvider,
            TestProfile: this.ChannelForm.value.TestProfile,
            Currency: this.ChannelForm.value.Currency

          }
          this._apiService.post(config.urlpath + 'api/addChannel', addbody).subscribe(result => {
            if (result.Success === true) {
              //debugger;
              $('#ModalClsbtn').click();
              this.notifier.notify('success', 'Channel Added Successfully');
              // setTimeout(
              //   function () {
              //     //location.reload(true);
              //   }, 100);
              this.GetPartner();
            } else if(result.ErrorMessage == 'Duplicate'){
              // $('#ModalClsbtn').click();
              this.notifier.notify('error', 'Channel Already Exists');
              // setTimeout(
              //   function () {
              //     location.reload(true);
              //   }, 100);
              this.GetPartner();

            }
            else{
              this.notifier.notify('error', 'An Error Occured');
              // setTimeout(
              //   function () {
              //     location.reload(true);
              //   }, 100);
              this.GetPartner();
            }
          },
            error => {
              console.log(error);
            }
          );
        }        
        }
        else{
          this.notifier.notify('error', 'Please enter or select all fields');
        }
    }
      editEnterprisePartner(item: any) {
    debugger;
    this.callForAddEnterprisePartner=false;
    this.form.controls.EnterprisePartnerID.patchValue(item.EnterprisePartnerID);
    this.form.controls.Enterprise.patchValue(item.EnterpriseID);
    this.form.controls.EnterprisePartner.patchValue(item.EnterprisePartner);
    this.form.controls.EnterprisePartnerCode.patchValue(item.EnterprisePartnerCode);
  }

  UpdatePartner(item) {
    debugger
    var UpdateBody = {
      EnterprisePartnerID: this.form.controls.EnterprisePartnerID.value,
      EnterpriseID: this.form.controls.Enterprise.value,
      EnterprisePartner: this.form.value.EnterprisePartner,
      EnterprisePartnerCode: this.form.value.EnterprisePartnerCode,
      // ChannelType: this.form.controls.ChannelType.value,
      // Language: this.form.controls.Language.value,
      // Country: this.form.controls.Country.value,
      // PriceLogicType: this.form.controls.PriceLogicType.value,
      // LogisticProvider: this.form.controls.LogisticProvider.value,
      // TestProfile: this.form.controls.TestProfile.value
    };
    this._apiService.post(config.urlpath + 'api/addpartner', UpdateBody).subscribe(result => {
      if (result.Success === true) {
        //debugger;
        this.GetPartner();
        $('#ModalClsbtn').click();
        this.notifier.notify('success', 'Enterprise Updated Successfully');        
      } else {
        //$('#ModalClsbtn').click();
        this.notifier.notify('error', 'An Error Occured');
      }
    },
      error => {
        console.log(error);
      }
    );

  }

  onChange(event, item: any) {
    debugger;
    var IsActiveBody = {
      EnterprisePartnerID: item,
      IsActive: event
    };
    this._apiService.post(config.urlpath + 'api/addpartner', IsActiveBody).subscribe(result => {
      debugger;
      if (event) {
        this.notifier.notify('success', 'Enterprise Activated Successfully');
      }
      else {
        this.notifier.notify('warning', 'Enterprise Deactivated Successfully');
      }
      console.log(result);
    })
  }
  keyPressName(event: any) {
    //debugger;
    const pattern = /^[a-zA-Z ]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  editchannel(item)
  {
    debugger;
    this.partnerID = item.EnterprisePartnerID;
    this.partnerName = item.EnterprisePartner;
    this.showpartnerChannelList = [];
    this.showpartnerChannelList =  this.partnerChannelList.filter(x=>x.EnterprisePartnerID == this.partnerID);    
    this.ChannelForm.controls['ChannelType'].setValue('');
    this.ChannelForm.controls['Language'].setValue('');
    this.ChannelForm.controls['Country'].setValue('');
    this.ChannelForm.controls['PriceLogicType'].setValue('');
    this.ChannelForm.controls['LogisticProvider'].setValue('');
    this.ChannelForm.controls['TestProfile'].setValue('');    
    this.ChannelForm.controls['Currency'].setValue('');
  }
}
export interface partnerInfo {
  EnterprisePartnerID: number;
  EnterprisePartner: string ;
  EnterprisePartnerCode: string;
  Enterprise: string;
}